/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import { Tab } from './Tab';
import { State } from '@store/index';

const Container = styled.div`
  display: flex;
`;

export const Tabs = () => {
  const tabs = useSelector((state: State) => state.tabs.list);

  return (
    <Container>
      {tabs.map((tab) => (
        <Tab key={tab.flow_id} label={tab.label} tab_flow_id={tab.flow_id} />
      ))}
    </Container>
  );
};

export default Tabs;
